module.exports = __webpack_public_path__ + "static/media/L1.765a136c.png";